<div class="card-title-block-non-sticky" *ngIf="(isSAOrderNotFound || scheduleBusinessOrder === undefined) && !isLoading">
	<copo-back-button></copo-back-button>
	<span class="card-title-label" translate>order-card.data-not-found</span>
</div>
<div class="sidenav-content" *ngIf="!isSAOrderNotFound && !(scheduleBusinessOrder === undefined && !isLoading)">
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading && scheduleBusinessOrder else loading">
			<ng-container *ngIf="scheduleBusinessOrder">
				<div class="card-title-block-non-sticky">
					<copo-back-button></copo-back-button>
					<span class="card-title-label" translate>schedule-business-order.card</span>
					<span class="card-title-label">{{ scheduleBusinessOrder.customerOrderNumber }}</span>
					<span class="card-title-label">{{ scheduleBusinessOrder.supplierOrderNumber }}</span>
					<button class="detailed-report-button" *ngIf="scheduleBusinessOrderNeeds && scheduleBusinessOrderNeeds.needsForTwelveWeeks" type="button"
					(click)="detailedReport()"	mat-button>
					<span class="survey-button-label">Detailed Report</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:download"></mat-icon>
				</button>
				</div>
				<div class="grid-6 copo-container">
					<div class="grid-column-one-full">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>order.card.information</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>schedule-business-order.sa-business-status</div>
										<div class="card-content-value">{{ scheduleBusinessOrder|copoModelInfo:'businessStatusDescription' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.supplier</div>
										<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'supplierDescription' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>settings.order.customer</div>
										<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'customerOrderNumber' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.supplier.order.number</div>
										<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'supplierOrderNumber' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>schedule-business-order.reference-of-alignment</div>
										<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo: 'referenceOfAlignmentDescription' }}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>schedule-business-order.interpretation-delivery-date</div>
										<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo: 'interpretationDeliveryDateDescription'}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.mill</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.millDescription }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.responsible.order.manager</div>
										<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'orderManagerDescription' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>schedule-business-order-filter.customer-article-reference</div>
										<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'customerArticleReference' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>schedule-business-order.SA-unit</div>
										<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'salesUnit' }}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.mill.order.number</div>
										<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'millOrderNumber' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>schedule-business-order.order-reason</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.orderReasonDescription }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>schedule-business-order.pds-instruction</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.pdsInstructionDescription }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>schedule-business-order.time-of-alignment</div>
										<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo: 'timeOfAlignmentDescription' }}</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>schedule-business-order.order-follow-up-schedule</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="card-container-row">
							<div class="card-container-column card-column-center">
								<mat-icon class="card-icon-tonnage" svgIcon="in_production"></mat-icon>
								<span class="card-container-title" translate>order-tracking.in.production</span>
								<span class="card-container-value">{{ (scheduleBusinessOrder.qtyInProduction ? scheduleBusinessOrder.qtyInProduction : 0) | copoNumber:'weight': scheduleBusinessOrder.salesUnit }}</span>
							</div>
							<div class="card-container-column card-column-center">
								<mat-icon class="card-icon-tonnage" svgIcon="in_stock"></mat-icon>
								<span class="card-container-title" translate>schedule-business-order.plant-stock</span>
								<span class="card-container-value">{{ (scheduleBusinessOrder.qtyAvailableReadyToShip ? scheduleBusinessOrder.qtyAvailableReadyToShip : 0) | copoNumber:'weight': scheduleBusinessOrder.salesUnit }}</span>
							</div>
							<div class="card-container-column card-column-center">
								<mat-icon class="card-icon-tonnage" svgIcon="stock_blocked"></mat-icon>
								<span class="card-container-title" translate>schedule-business-order.stock-blocked</span>
								<span class="card-container-value">{{ (scheduleBusinessOrder.qtyBlocked ? scheduleBusinessOrder.qtyBlocked : 0) | copoNumber:'weight': scheduleBusinessOrder.salesUnit }}</span>
							</div>
							<div class="card-container-column card-column-center">
								<mat-icon class="card-icon-tonnage" svgIcon="in_transit"></mat-icon>
								<span class="card-container-title" translate>schedule-business-order.in-transit-stock</span>
								<span class="card-container-value">{{ (scheduleBusinessOrder.qtyAvailableInTransit ? scheduleBusinessOrder.qtyAvailableInTransit : 0) | copoNumber:'weight': scheduleBusinessOrder.salesUnit }}</span>
							</div>
							<div class="card-container-column card-column-center">
								<mat-icon class="card-icon-tonnage" svgIcon="consignment_stock"></mat-icon>
								<span class="card-container-title" translate>order-card.batches-consignment-stock</span>
								<span class="card-container-value">{{ (scheduleBusinessOrder.qtyAvailableInConsignment ? scheduleBusinessOrder.qtyAvailableInConsignment: 0 ) | copoNumber:'weight': scheduleBusinessOrder.salesUnit }}</span>
							</div>
							<div class="card-container-column card-column-center">
								<mat-icon class="card-icon-tonnage" svgIcon="realized_cumul"></mat-icon>
								<span class="card-container-title" translate>schedule-business-order.realized-cumul</span>
								<span class="card-container-value">{{ (scheduleBusinessOrder.realizedCumul ? scheduleBusinessOrder.realizedCumul : 0) | copoNumber:'weight': scheduleBusinessOrder.salesUnit }}</span>
							</div>
						</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>shipment.filter.customer</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="card-content-block">
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>schedule-business-order.cem-partner</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'cemPartnerDescription' }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>order.end.user</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'endUserDescription' }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>schedule-business-order.sfc-country</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'sfcCountry' }}</div>
								</div>
							</div>
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>shipment.filter.customer</div>
									<div class="card-content-value">{{ scheduleBusinessOrder.soldToDescription }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>order.bill.to</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'billToDescription' }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>schedule-business-order.country-of-scf</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'sfcDescription' }}</div>
								</div>
							</div>
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>order.ship.to</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'shipToDescription' }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>schedule-business-order.stock-partner</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'stockPartnerDescription' }}</div>
								</div>
							</div>
						</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>schedule-business-order.delivery</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="card-content-block">
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>schedule-business-order.delivery.address</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'deliveryAddress' }}</div>
								</div>
								<div class="card-content-info">
									<div class="card-content-label" translate>schedule-business-order.transport-mode</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'transportModeDescription' }}</div>
								</div>
							</div>
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>schedule-business-order.incoterm</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'incoterm' }}</div>
								</div>
							</div>
							<div class="card-contents-infos">
								<div class="card-content-info">
									<div class="card-content-label" translate>schedule-business-order.delivery.mode</div>
									<div class="card-content-value">{{ scheduleBusinessOrder | copoModelInfo:'deliveryMode' }}</div>
								</div>
							</div>
						</div>
						</mat-expansion-panel>
					</div>
					<div class="card-block grid-column-one-full" *ngIf="orderCharacteristics && orderCharacteristics.length>0">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>order-tracking.product</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info" *ngIf="scheduleBusinessOrder.productDescription">
										<div class="card-content-label" translate>order-tracking.product.description</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.productDescription }}</div>
									</div>
									<div class="card-content-info" *ngIf="scheduleBusinessOrder.choiceDescription">
										<div class="card-content-label" translate>order-tracking.choice</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.choiceDescription }}</div>
									</div>
									<div class="card-content-info" *ngIf="scheduleBusinessOrder.customerArticleReference">
										<div class="card-content-label" translate>order-tracking.customerArticleReference</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.customerArticleReference }}</div>
									</div>
									<div class="card-content-info" *ngIf="scheduleBusinessOrder.customerTemplateReference">
										<div class="card-content-label" translate>order.customer-template-reference</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.customerTemplateReference }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('PA01')">
										<div class="card-content-label">{{ getCharacteristic('PA01')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('PA01') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('US05')">
										<div class="card-content-label">{{ getCharacteristic('US05')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('US05') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('QU01')">
										<div class="card-content-label">{{ getCharacteristic('QU01')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('QU01') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="scheduleBusinessOrder.steelgradeDescription">
										<div class="card-content-label" translate>order.steelgrade</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.steelgradeDescription }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU09')">
										<div class="card-content-label">{{ getCharacteristic('SU09')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('SU09') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="scheduleBusinessOrder.thickness">
										<div class="card-content-label" translate>batch-card.thickness</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.thickness }}</div>
									</div>
									<div class="card-content-info" *ngIf="scheduleBusinessOrder.width">
										<div class="card-content-label" translate>batch-card.width</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.width }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>batch-card.length</div>
										<div class="card-content-value">{{ scheduleBusinessOrder.length }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('WG11')">
										<div class="card-content-label">{{ getCharacteristic('WG11')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('WG11')?.valueNum }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('WG21')">
										<div class="card-content-label">{{ getCharacteristic('WG21')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('WG21') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('WG27')">
										<div class="card-content-label">{{ getCharacteristic('WG27')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('WG27') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('WG97')">
										<div class="card-content-label">{{ getCharacteristic('WG97')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('WG97') | copoCharac }}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info" *ngIf="getCharacteristic('CO01')">
										<div class="card-content-label">{{ getCharacteristic('CO01')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO01') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO03')">
										<div class="card-content-label">{{ getCharacteristic('CO03')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO03') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO25')">
										<div class="card-content-label">{{ getCharacteristic('CO25')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO25') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO15')">
										<div class="card-content-label">{{ getCharacteristic('CO15')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO15') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO76')">
										<div class="card-content-label">{{ getCharacteristic('CO76')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO76') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO37')">
										<div class="card-content-label">{{ getCharacteristic('CO37')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO37') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO19')">
										<div class="card-content-label">{{ getCharacteristic('CO19')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO19') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO17')">
										<div class="card-content-label">{{ getCharacteristic('CO17')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO17') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO71')">
										<div class="card-content-label">{{ getCharacteristic('CO71')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO71') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO80')">
										<div class="card-content-label">{{ getCharacteristic('CO80')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO80') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO20')">
										<div class="card-content-label">{{ getCharacteristic('CO20')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO20') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO18')">
										<div class="card-content-label">{{ getCharacteristic('CO18')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO18') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO72')">
										<div class="card-content-label">{{ getCharacteristic('CO72')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CO72') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU08')">
										<div class="card-content-label">{{ getCharacteristic('SU08')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('SU08') | copoCharac }}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info" *ngIf="getCharacteristic('DI11')">
										<div class="card-content-label">{{ getCharacteristic('DI11')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('DI11') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('DI40')">
										<div class="card-content-label">{{ getCharacteristic('DI40')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('DI40') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('DI12')">
										<div class="card-content-label">{{ getCharacteristic('DI12')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('DI12') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('PP01')">
										<div class="card-content-label">{{ getCharacteristic('PP01')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('PP01') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('DI14')">
										<div class="card-content-label">{{ getCharacteristic('DI14')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('DI14') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('DI33')">
										<div class="card-content-label">{{ getCharacteristic('DI33')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('DI33') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU02')">
										<div class="card-content-label">{{ getCharacteristic('SU02')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('SU02') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU03')">
										<div class="card-content-label">{{ getCharacteristic('SU03')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('SU03') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU12')">
										<div class="card-content-label">{{ getCharacteristic('SU12')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('SU12') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU34')">
										<div class="card-content-label">{{ getCharacteristic('SU34')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('SU34') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('US02')">
										<div class="card-content-label">{{ getCharacteristic('US02')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('US02') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('Surft')">
										<div class="card-content-label">{{ getCharacteristic('Surft')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('Surft') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('PP03')">
										<div class="card-content-label">{{ getCharacteristic('PP03')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('PP03') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('PP05')">
										<div class="card-content-label">{{ getCharacteristic('PP05')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('PP05') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('PP06')">
										<div class="card-content-label">{{ getCharacteristic('PP06')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('PP06') | copoCharac }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CF01')">
										<div class="card-content-label">{{ getCharacteristic('CF01')?.description }}</div>
										<div class="card-content-value">{{ getCharacteristic('CF01') | copoCharac }}</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full" *ngIf="scheduleBusinessOrderNeeds && gridNeedsOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>schedule-business-order.needs</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="card-container-row">
							<div class="needs-header-row">
								<span class="header-label" translate>schedule-business-order.situation-overview</span>
								<mat-icon [ngClass]="{'green-gor-color': scheduleBusinessOrderNeeds.gor === 'G',
									'red-gor-color': scheduleBusinessOrderNeeds.gor === 'R',
									'yellow-gor-color': scheduleBusinessOrderNeeds.gor === 'O'}" svgIcon="gor_icon">
								</mat-icon>
							</div>
							<div class="needs-header-row label-orange-color">
								<span class="header-label" translate>schedule-business-order.lead-delay</span>
								<span>{{scheduleBusinessOrderNeeds.lead}}</span>
							</div>
						</div>
						<div class="needs-container-row">
							<span class="header-label" translate>schedule-business-order.customer-expected-cumul</span>
							<span class="header-label label-orange-color">{{ scheduleBusinessOrderNeeds.customerExpectedCumul }}</span>
						</div>
						<div class="needs-container-row">
							<span class="header-label" translate>schedule-business-order.customer-realized-cumul</span>
							<span class="header-label label-orange-color">{{ scheduleBusinessOrderNeeds.customerRealizedCumul }}</span>
						</div>
						<div class="copo-card-grid-container card-grid-padding">
							<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridNeedsOptions"
								[modules]="agGridModules" (gridReady)="onGridReady($event)"
								(viewportChanged)="onViewportChanged($event)">
							</ag-grid-angular>
						</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full" *ngIf="blockedBatches && blockedBatches.length > 0 && gridBatchBlockedOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate class="batch-title-spacing">order-card.batches-blocked</span>
									<span translate class="gross-net-title"
										[translateParams]="{value: sumGrossBlockedBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossBlockedBatches">order-card.gross</span>
									<span translate [translateParams]="{value: sumNetBlockedBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetBlockedBatches">order-card.net</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="copo-card-grid-container card-grid-padding">
							<ag-grid-angular
									class="ag-theme-balham"
									[gridOptions]="gridBatchBlockedOptions"
									[modules]="agGridModules"
									(gridReady)="onGridReady($event)"
									(viewportChanged)="onViewportChanged($event)"
							></ag-grid-angular>
						</div>
						</mat-expansion-panel>
					</div>

					<!-- Blocked batches ends here -->
					<!-- Available batches starts here -->
					<div class="sub-title grid-column-one-full" *ngIf="(readyToShipBatches && readyToShipBatches.length > 0) ||
						(landTransitBatches && landTransitBatches.length > 0) || (atReshipperBatches && atReshipperBatches.length > 0) ||
						(onVesselBatches && onVesselBatches.length > 0) || (overseasTransitBatches && overseasTransitBatches.length > 0)
						|| (transitToCustomerBatches && transitToCustomerBatches.length > 0) || (consignmentStockBatches && consignmentStockBatches.length > 0)">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate class="batch-title-spacing">order-card.batches-available</span>
									<span translate class="gross-net-title"
										[translateParams]="{value: sumGrossAvailableBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossAvailableBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetAvailableBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetAvailableBatches">order-card.net</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<ng-container *ngIf="readyToShipBatches && readyToShipBatches.length > 0 && gridBatchReadyToShipOptions">
							<div class="card-sub-title">
								<span class="card-title-label" translate>order-card.batches-ready-to-ship</span>
								<span class="card-title-label" translate
									[translateParams]="{value: sumGrossReadyToShipBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumGrossReadyToShipBatches">order-card.gross</span>
								<span translate
									[translateParams]="{value: sumNetReadyToShipBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumNetReadyToShipBatches">order-card.net</span>
							</div>
							<div class="copo-card-grid-container card-grid-padding">
								<ag-grid-angular
										class="ag-theme-balham"
										[gridOptions]="gridBatchReadyToShipOptions"
										[modules]="agGridModules"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"
								></ag-grid-angular>
							</div>
						</ng-container>
						<ng-container *ngIf="landTransitBatches && landTransitBatches.length > 0 && gridBatchLandTransitOptions">
							<div class="card-sub-title card-title-label">
								<span class="card-title-label" translate>order-card.batches-land-transit</span>
								<span class="card-title-label" translate
									[translateParams]="{value: sumGrossLandTransitBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumGrossLandTransitBatches">order-card.gross</span>
								<span translate
									[translateParams]="{value: sumNetLandTransitBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumNetLandTransitBatches">order-card.net</span>
							</div>
							<div class="copo-card-grid-container card-grid-padding">
								<ag-grid-angular
										class="ag-theme-balham"
										[gridOptions]="gridBatchLandTransitOptions"
										[modules]="agGridModules"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"
								></ag-grid-angular>
							</div>
						</ng-container>
						<ng-container *ngIf="atReshipperBatches && atReshipperBatches.length > 0 && gridBatchAtReshipperOptions">
							<div class="card-sub-title">
								<span class="card-title-label" translate>order-card.batches-at-reshipper</span>
								<span class="card-title-label" translate
									[translateParams]="{value: sumGrossAtReshipperBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumGrossAtReshipperBatches">order-card.gross</span>
								<span translate
									[translateParams]="{value: sumNetAtReshipperBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumNetAtReshipperBatches">order-card.net</span>
							</div>
							<div class="copo-card-grid-container card-grid-padding">
								<ag-grid-angular
										class="ag-theme-balham"
										[gridOptions]="gridBatchAtReshipperOptions"
										[modules]="agGridModules"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"
								></ag-grid-angular>
							</div>
						</ng-container>
						<ng-container *ngIf="onVesselBatches && onVesselBatches.length > 0 && gridBatchOnVesselOptions">
							<div class="card-sub-title">
								<span class="card-title-label" translate>order-card.batches-on-vessel</span>
								<span class="card-title-label" translate
									[translateParams]="{value: sumGrossOnVesselBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumGrossOnVesselBatches">order-card.gross</span>
								<span translate
									[translateParams]="{value: sumNetOnVesselBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumNetOnVesselBatches">order-card.net</span>
							</div>
							<div class="copo-card-grid-container card-grid-padding">
								<ag-grid-angular
										class="ag-theme-balham"
										[gridOptions]="gridBatchOnVesselOptions"
										[modules]="agGridModules"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"
								></ag-grid-angular>
							</div>
						</ng-container>
						<ng-container *ngIf="overseasTransitBatches && overseasTransitBatches.length > 0 && gridBatchOverseasTransitOptions">
							<div class="card-sub-title">
								<span class="card-title-label" translate>order-card.batches-overseas-transit</span>
								<span class="card-title-label" translate
									[translateParams]="{value: sumGrossOverseasTransitBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumGrossOverseasTransitBatches">order-card.gross</span>
								<span translate
									[translateParams]="{value: sumNetOverseasTransitBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumNetOverseasTransitBatches">order-card.net</span>
							</div>
							<div class="copo-card-grid-container card-grid-padding">
								<ag-grid-angular
										class="ag-theme-balham"
										[gridOptions]="gridBatchOverseasTransitOptions"
										[modules]="agGridModules"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"
								></ag-grid-angular>
							</div>
						</ng-container>
						<ng-container *ngIf="transitToCustomerBatches && transitToCustomerBatches.length > 0 && gridBatchTransitToCustomerOptions">
							<div class="card-sub-title">
								<span class="card-title-label" translate>order-card.batches-transit-to-customer</span>
								<span class="card-title-label" translate
									[translateParams]="{value: sumGrossTransitToCustomerBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumGrossTransitToCustomerBatches">order-card.gross</span>
								<span translate
									[translateParams]="{value: sumNetTransitToCustomerBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumNetTransitToCustomerBatches">order-card.net</span>
							</div>
							<div class="copo-card-grid-container card-grid-padding">
								<ag-grid-angular
										class="ag-theme-balham"
										[gridOptions]="gridBatchTransitToCustomerOptions"
										[modules]="agGridModules"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"
								></ag-grid-angular>
							</div>
						</ng-container>
						<ng-container *ngIf="consignmentStockBatches && consignmentStockBatches.length > 0 && gridBatchConsignmentStockOptions">
							<div class="card-sub-title">
								<span class="card-title-label" translate>order-card.batches-consignment-stock</span>&nbsp;
								<span class="card-title-label" translate
									[translateParams]="{value: sumGrossConsignmentStockBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumGrossConsignmentStockBatches">order-card.gross</span>&nbsp;
								<span translate
									[translateParams]="{value: sumNetConsignmentStockBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumNetConsignmentStockBatches">order-card.net</span>
							</div>
							<div class="copo-card-grid-container card-grid-padding">
								<ag-grid-angular
										class="ag-theme-balham"
										[gridOptions]="gridBatchConsignmentStockOptions"
										[modules]="agGridModules"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"
								></ag-grid-angular>
							</div>
						</ng-container>
						</mat-expansion-panel>
					</div>

					<!-- Available batches card ends here -->
					<!-- Delivered batches card starts here -->
					<div class="grid-column-one-full" *ngIf="deliveredBatches && deliveredBatches.length > 0 && gridBatchDeliveredOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate class="batch-title-spacing">order-card.batches-delivered</span>
									<span translate class="gross-net-title"
									[translateParams]="{value: sumGrossDeliveredBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumGrossDeliveredBatches">order-card.gross</span>
									<span translate
									[translateParams]="{value: sumNetDeliveredBatches | copoNumber: 'weight':'t'}"
									*ngIf="sumNetDeliveredBatches">order-card.net</span>
								</mat-panel-title>
								<a color="primary" (click)="$event.preventDefault();seeAllBatches()" class="view-all" href="#">
									<span translate>see.all.batches</span>
								</a>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="copo-card-grid-container card-grid-padding">
							<ag-grid-angular
									class="ag-theme-balham"
									[gridOptions]="gridBatchDeliveredOptions"
									[modules]="agGridModules"
									(gridReady)="onGridReady($event)"
									(viewportChanged)="onViewportChanged($event)"
							></ag-grid-angular>
						</div>
						</mat-expansion-panel>
					</div>
					<!-- Delivered batches ends here -->
					<div class="card-block grid-column-one-full footer-margin" #documents copoAfterViewInit (afterviewinit)="autoScrollToElement(documents)" *ngIf="gridCommercialDocumentsOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span [ngClass]="{'highlight-title': isCommercialDocumentFragment}" translate>schedule-business-order-card.commercial-documents</span>
								</mat-panel-title>
								<div *ngIf="documentResult && documentResult.results && documentResult.results.length > 0">
									<a color="primary" (click)="$event.preventDefault();seeAllDocuments()" class="view-all" href="#">
										<span translate>see.all.documents</span>
									</a>
								</div>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="copo-card-grid-container card-grid-padding">
							<ag-grid-angular *ngIf="!hasCommercialDocumentError" class="ag-theme-balham" [gridOptions]="gridCommercialDocumentsOptions"
								[overlayNoRowsTemplate]="overlayNoDocumentsTemplate" [modules]="agGridModules"
								(gridReady)="onGridReady($event)" (viewportChanged)="onViewportChanged($event)">
							</ag-grid-angular>
							<div *ngIf="hasCommercialDocumentError" class="document-error-box">
								<div translate>order-card.due-to-technical-issue</div>
								<mat-icon class="error-icon" svgIcon="md:running_with_error"></mat-icon>
								<div translate>order-card.we-are-actively-working</div>
							</div>
						</div>
						</mat-expansion-panel>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>